// *******************************************************************************
// 1.0 - Open dropdown
// *******************************************************************************

attachEvent('.dropdown__placeholder', 'click', (el) => {
  const dropdowns = document.querySelectorAll('.dropdown');
  const dropdownParent = el.target.closest('.dropdown');

  dropdowns.forEach((elem) => {
    if (elem === dropdownParent) {
      elem.classList.toggle('is-open');

      if (dropdownParent.classList.contains('dropdown--with-search')) {
        dropdownParent.querySelector('.dropdown__search-input').focus();
      }
    } else {
      elem.classList.remove('is-open');
    }
  });
});

// *******************************************************************************
// 2.0 - Click on dropdown option
// *******************************************************************************

const dropdownOptionElement = document.querySelectorAll('.dropdown__list-option');
const getHash = () => window.location.hash.replace(/^#/, '');

attachEvent('.dropdown__list-option', 'click', (ev) => {
  const dropdownParent = ev.target.closest('.dropdown');
  const dropdownPlaceholderText = dropdownParent.querySelectorAll('.dropdown__placeholder-text');

  if (!dropdownParent.classList.contains('dropdown--multiselect')) {
    // Change text
    const dropdownOptionText = ev.target.innerHTML;
    dropdownPlaceholderText[0].innerHTML = dropdownOptionText;
  }

  // Change location hash if it already exists
  const locationHash = getHash();
  if (locationHash) {
    const optionValue = ev.target.parentElement.querySelector('input').getAttribute('id');
    window.location.hash = `#${optionValue}`;
  }

  // Close the dropdown
  if (!dropdownParent.classList.contains('dropdown--multiselect')) {
    dropdownParent.classList.remove('is-open');
  }
  dropdownParent.classList.add('is-selected');
});

// *******************************************************************************
// 3.0 - Open a specific dropdown based on has in url
// *******************************************************************************

// document.addEventListener('DOMContentLoaded', () => {
//   const locationHash = getHash();

//   if (locationHash) {
//     const selectedElem = document.querySelectorAll(`#${locationHash}`);

//     // Loop throught elements to avoid errors if there is no element to be found
//     selectedElem.forEach((el) => {
//       // Set active selection
//       el.setAttribute('checked', 'true');

//       // Change text
//       const dropdownParent = el.closest('.dropdown');
//       const optionLabel = el.parentElement.querySelector('.dropdown__list-option');
//       const dropdownPlaceholder = dropdownParent.querySelectorAll('.dropdown__placeholder');
//       const dropdownOptionText = optionLabel.innerHTML;
//       dropdownPlaceholder[0].innerHTML = dropdownOptionText;
//     });
//   }
// });

document.addEventListener('click', (ev) => {
  const dropdowns = document.querySelectorAll('.dropdown');

  dropdowns.forEach((dropdown) => {
    const clickInside = dropdown.contains(ev.target);
    const dropdownSearchInput = dropdown.querySelector('.dropdown__search-input');
    if (!clickInside) {
      dropdown.classList.remove('is-open');

      if (dropdownSearchInput) {
        dropdownSearchInput.blur();
      }
    }
  });
});

// *******************************************************************************
// Dropdown Search
// *******************************************************************************
document.querySelectorAll('.dropdown--with-search').forEach((dropdownWithSearch) => {
  const dropdownSearch = dropdownWithSearch.querySelectorAll('.dropdown__search-input');
  dropdownSearch.forEach((input) => {
    const parent = input.closest('.dropdown');

    const filterItems = (inputValue) => {
      const searchValue = inputValue.value.toLowerCase();
      const options = parent.querySelectorAll('.dropdown__list-option');

      options.forEach((option) => {
        const listItem = option.innerHTML.toLowerCase();
        option.closest('.dropdown__list-item').style.display = listItem.includes(searchValue) ? 'block' : 'none';
      });
    };

    input.addEventListener('input', () => filterItems(input));
  });

  // Show no results
  const dropdownItems = dropdownWithSearch.querySelectorAll('.dropdown__list-item');
  const noResultsItem = dropdownWithSearch.querySelector('.no-results');

  const observer = new MutationObserver(() => {
    const allHidden = [...dropdownItems].every(item => getComputedStyle(item).display === 'none');
    noResultsItem.classList.toggle('is-active', allHidden);
  });

  const observerConfig = {
    attributes: true,
    attributeFilter: ['style'],
    subtree: true,
  };

  dropdownItems.forEach(item => observer.observe(item, observerConfig));
});
